import React from 'react'

/**
 * Header component
 * @returns {React.ReactElement} JSX.Element - the Header component
 */
function Header() {
  return (
    <header className="text-center">
      <h1>HRnet</h1>
    </header>
  )
}

export default Header
